import React from "react";
import { connect } from "react-redux";

import CreateActivityModal from "@app/component/createEditEntity/Activity/CreateActivityModal";
import { isCreateActivityModalVisible } from "@app/component/createEditEntity/Activity/store";
import { hideGlobalCreateActivityModal } from "@app/component/createEditEntity/Activity/store/actions";
import CreateCompanyModal from "@app/component/createEditEntity/CreateCompanyModal";
import { isCreateCompanyModalVisible } from "@app/component/createEditEntity/CreateCompanyModal/store";
import { hideGlobalCreateCompanyModal } from "@app/component/createEditEntity/CreateCompanyModal/store/actions";
import CreateDealModal from "@app/component/createEditEntity/CreateDealModal";
import { isCreateDealModalVisible } from "@app/component/createEditEntity/CreateDealModal/store";
import { hideGlobalCreateDealModal } from "@app/component/createEditEntity/CreateDealModal/store/actions";
import CreatePersonModal from "@app/component/createEditEntity/CreatePersonModal";
import { isCreatePersonModalVisible } from "@app/component/createEditEntity/CreatePersonModal/store";
import { hideGlobalCreatePersonModal } from "@app/component/createEditEntity/CreatePersonModal/store/actions";
import PostCreationModal from "@app/component/PostCreationModal";
import { isPostCreationModalVisible } from "@app/component/PostCreationModal/store";
import { hideGlobalPostCreationModal } from "@app/component/PostCreationModal/store/actions";
import { RootState } from "@app/store/rootReducer";

const GlobalCreateEntityModals = ({
  createActivityModalVisible,
  createCompanyModalVisible,
  createDealModalVisible,
  createPersonModalVisible,
  onHideCreateActivityModal,
  onHideCreateCompanyModal,
  onHideCreateDealModal,
  onHideCreatePersonModal,
  onHideGlobalPostCreationModal,
  postCreationModalVisible,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  return (
    <div>
      {createActivityModalVisible && (
        <CreateActivityModal onHide={() => onHideCreateActivityModal()} />
      )}
      {createCompanyModalVisible && (
        <CreateCompanyModal onHide={() => onHideCreateCompanyModal()} />
      )}
      {createDealModalVisible && <CreateDealModal onHide={() => onHideCreateDealModal()} />}
      {createPersonModalVisible && <CreatePersonModal onHide={() => onHideCreatePersonModal()} />}
      {postCreationModalVisible && <PostCreationModal onHide={onHideGlobalPostCreationModal} />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  createActivityModalVisible: isCreateActivityModalVisible(state),
  createCompanyModalVisible: isCreateCompanyModalVisible(state),
  createDealModalVisible: isCreateDealModalVisible(state),
  createPersonModalVisible: isCreatePersonModalVisible(state),
  postCreationModalVisible: isPostCreationModalVisible(state),
});

const mapDispatchToProps = {
  onHideCreateActivityModal: hideGlobalCreateActivityModal,
  onHideCreateCompanyModal: hideGlobalCreateCompanyModal,
  onHideCreateDealModal: hideGlobalCreateDealModal,
  onHideCreatePersonModal: hideGlobalCreatePersonModal,
  onHideGlobalPostCreationModal: hideGlobalPostCreationModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalCreateEntityModals);
